import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { processEnvServer } from "@RHCommerceDev/hooks/useSsrHooks";
import { getReqContext } from "@RHCommerceDev/utils/reqContext";

const useAkamaiRouting = () => {
  const req = getReqContext();
  const location = useLocation();
  const Location = processEnvServer ? req.path : location?.pathname;

  const getLiveEndpoint = () => {
    const returnCookie = (arr: string | undefined) =>
      arr
        ?.split("; ")
        .find(row => row.startsWith("x-live-endpoint="))
        ?.split("=")[1] || null;

    return !processEnvServer
      ? returnCookie(document.cookie)
      : returnCookie(req?.headers?.cookie);
  };

  const [liveEndpoint, setLiveEndpoint] = useState(getLiveEndpoint());

  useEffect(() => {
    const currentEndpoint = getLiveEndpoint();
    if (!processEnvServer) {
      if (currentEndpoint && liveEndpoint && currentEndpoint !== liveEndpoint) {
        // eslint-disable-next-line no-self-assign
        window.location.href = window?.location?.href; //reloding page here
      } else {
        setLiveEndpoint(currentEndpoint);
      }
    } else {
      if (
        req &&
        currentEndpoint &&
        liveEndpoint &&
        currentEndpoint !== liveEndpoint
      ) {
        req.res?.writeHead(302, { Location: req.path }).end();
      }
    }
  }, [Location]);

  return null;
};

export default useAkamaiRouting;
